import { render, staticRenderFns } from "./DevDashboard.vue?vue&type=template&id=6cf9cebc&scoped=true"
import script from "./DevDashboard.vue?vue&type=script&lang=js"
export * from "./DevDashboard.vue?vue&type=script&lang=js"
import style0 from "./DevDashboard.vue?vue&type=style&index=0&id=6cf9cebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf9cebc",
  null
  
)

export default component.exports